import Navbar from "../components/landingPage/Navbar";
import Hero from "../components/landingPage/Hero";
import Stats from "../components/landingPage/Stats";
import Features from "../components/landingPage/Features";
import HowItWorks from "../components/landingPage/HowItWorks";
import ExploreCentres from "../components/landingPage/ExploreCentres";
import BuiltFor from "../components/landingPage/BuiltFor";
import CTA from "../components/landingPage/CTA";
import Footer from "../components/landingPage/Footer";

export default function Landing() {
  return (
    <div>
      <Navbar />
      <Hero />
      <Stats />
      <Features />
      <HowItWorks />
      <ExploreCentres />
      <BuiltFor />
      <CTA />
      <Footer />
    </div>
  );
}